var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"admin_home"}},[_c('h3',[_vm._v(_vm._s(_vm.$data.textHash["misc"]["welcome"]))]),_c('Example')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }